import React from "react";
import Page from "../components/Page";

// Import
import { useSelector } from "react-redux";

// Import for Display
import LoginPage from "./LoginPage";
import GrabElement from "../components/GrabElement";
import LoadingPage from "./LoadingPage";

function CalendarPage() {
  // Accessing data
  const { data } = useSelector((state) => state.cms);
  const collectionSlug = "calendars";
  const collectionData = data[collectionSlug];

  const { user } = useSelector((state) => state.auth);
  const element = GrabElement(collectionData, user.currentRole);

  // Redirect to login page if there isn't a user logged in.
  if (!user) return <LoginPage />;
  if (!element) return <LoadingPage />;

  return (
    <Page data-wf-page="635c3881786efdc7f0e6ee12" data-wf-site="634efd6b20b65bfc05be44e4">
      <div className="section wf-section">
        <div className="containercentered w-container">
          <h1 className="textcenter">{user.currentRole} Calendar</h1>
          <div className="calendar w-embed w-iframe">
            <iframe title="calendar" src={element.attributes.url} style={{ border: "solid 1px #777" }} width="100%" height={500} frameBorder={0} scrolling="no" />
          </div>
        </div>
      </div>
    </Page>
  );
}

export default CalendarPage;
